/* BV Cart 3x2 - mostra GRATIS sul pezzo meno caro nel carrello (visivo, pre-checkout) */
(function(){
  if (window.__bv3x2) return;
  window.__bv3x2 = true;
  var st = document.createElement('style');
  st.textContent = '.bv-3x2-free__old{opacity:.5;text-decoration:line-through;margin-right:5px;}.bv-3x2-free__new{color:#c40000;font-weight:700;}';
  document.head.appendChild(st);
  function fmt(c){ return (c/100).toFixed(2).replace('.',',') + ' €'; }
  function run(){
    if(!document.querySelector('.cart-items__price')) return;
    fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(cart){
      var items = cart.items || [];
      var units = [];
      items.forEach(function(it){ for(var q=0;q<it.quantity;q++){ units.push({key:it.key, price:it.price}); } });
      var freeUnits = Math.floor(units.length/3);
      if(freeUnits < 1) return;
      units.sort(function(a,b){ return a.price-b.price; });
      var freeByKey = {};
      for(var i=0;i<freeUnits;i++){ freeByKey[units[i].key] = (freeByKey[units[i].key]||0)+1; }
      Object.keys(freeByKey).forEach(function(key){
        var row = document.querySelector('.cart-items__table-row[data-key="'+key+'"]') || document.querySelector('[data-key="'+key+'"]');
        if(!row) return;
        var cell = row.querySelector('.cart-items__price');
        if(!cell || cell.getAttribute('data-bv3x2')==='1') return;
        var it=null; for(var j=0;j<items.length;j++){ if(items[j].key===key){ it=items[j]; break; } }
        if(!it) return;
        var paidQ = it.quantity - freeByKey[key];
        var newLine = paidQ * it.price;
        var tc = cell.querySelector('text-component') || cell;
        tc.innerHTML = '<span class="bv-3x2-free__old">'+fmt(it.original_line_price)+'</span><span class="bv-3x2-free__new">'+(newLine<=0?'GRATIS':fmt(newLine))+'</span>';
        cell.setAttribute('data-bv3x2','1');
      });
    }).catch(function(){});
  }
  function sched(){ setTimeout(run,250); }
  document.addEventListener('cart:update', sched);
  document.addEventListener('DOMContentLoaded', sched);
  if(document.readyState !== 'loading') sched();
})();
